import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Login from '@/components/Login'
import SignUp from '@/components/SignUp'
import NewContact from '@/components/NewContact'
import ViewContact from '@/components/ViewContact'
import ViewCompany from '@/components/ViewCompany'
import NewCompany from '@/components/NewCompany'
import EditContact from '@/components/EditContact'
import EditCompany from '@/components/EditCompany'
import firebase from 'firebase'

Vue.use(Router)

let router = new Router({
  base: '/', 
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/hello',
      name: 'Hello',
      component: Hello,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/add-contact',
      name: 'NewContact',
      component: NewContact,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/view-contact/:contact',
      name: 'ViewContact',
      component: ViewContact,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/view-company/:contact',
      name: 'ViewCompany',
      component: ViewCompany,
      props: true,
      meta: {
        requiresAuth: true
      }
    },


    {
      path: '/edit-contact/:contact',
      name: 'EditContact',
      component: EditContact,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    
    {
      path: '/edit-company/:contact',
      name: 'EditCompany',
      component: EditCompany,
      props: true,
      meta: {
        requiresAuth: true
      }
    },


    {
      path: '*',
      redirect: '/login'
    },
    
/*
    {
      path: '/add-company',
      name: 'NewCompany',
      component: NewCompany,
      meta: {
        requiresAuth: true
      }
    },
*/
    
        
  ]
})


router.beforeEach( (to, from, next ) => {
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some( record => record.meta.requiresAuth );
  
  if ( requiresAuth && !currentUser ) next('login')
  else if ( !requiresAuth && currentUser ) next('hello')
  else next()
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js